import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
const DetailHeader = ({ title }) => {
  const styles = StyleSheet.create({
    titleContainer: {
      width: "100%",
      backgroundColor: "#E4E4E4",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      marginTop: "10px",
      marginBottom: "5px",
    },
    title: {
      fontSize: "11px",
      fontWeight: "500",
      color: "#333333",
    },
  });
  return (
    <Fragment>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>{title}</Text>
      </View>
    </Fragment>
  );
};

export default DetailHeader;
